"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCICContentTree = exports.isAccount = exports.getIsCicContentTree = exports.getConfig = exports.default = void 0;
var _config = _interopRequireDefault(require("./csc/config/config"));
var _config2 = _interopRequireDefault(require("./cic/config/config"));
var _DomHelper = require("./utils/DomHelper");
var isCICContentTree = exports.isCICContentTree = process.env.NODE_ENV !== 'production' && window.location.href.indexOf('csc') === -1 || (0, _DomHelper.getIdDataset)('cscn-config', 'isCicContentTree') === 'true';
window.isCicContentTree = isCICContentTree;
var CONFIG = isCICContentTree ? _config2.default : _config.default;
var getIsCicContentTree = exports.getIsCicContentTree = function getIsCicContentTree() {
  return isCICContentTree;
};
var isAccount = exports.isAccount = !!(0, _DomHelper.getInputValueIfExists)('is-account-config');
var _default = exports.default = CONFIG;
var getConfig = exports.getConfig = function getConfig() {
  return CONFIG;
};